import { render } from "./WhoDropdown.vue?vue&type=template&id=52d18afa&scoped=true"
import script from "./WhoDropdown.vue?vue&type=script&lang=js"
export * from "./WhoDropdown.vue?vue&type=script&lang=js"

import "./WhoDropdown.vue?vue&type=style&index=0&id=52d18afa&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d18afa"]])

export default __exports__